import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_segment_ext_RowClass } from '../../../dbschema/bl_dgmkt_segment_exts.model'

export class SegmentExtensionContainerModel extends BaseContainerModel {
    bl_dgmkt_segment_ext: bl_dgmkt_segment_ext_RowClass = new bl_dgmkt_segment_ext_RowClass();
}